import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment-timezone";
import "./UnplannedMedicalVisits.css";
import { useSelector } from "react-redux";
import GenericModal from "../../GenericComponents/GenericModal/GenericModal";
import TaskNotes from "../../GenericComponents/TaskNotes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const UnplannedMedicalVisitsList = ({ ...props }) => {
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [notesModalData, setNotesModalData] = useState({});
    const profileData = useSelector((state) => state?.dashboard);

    const dateFormatter = (cell, row) => {
        return `${moment(row.eventTimestamp).format("MM/DD/YYYY")}   ${moment(
            row.eventTimestamp
        ).format("hh:mm A")}`;
    };

    const admissionDateFormatter = (cell, row) => {
        //${moment(row.eventTimestamp).format("MMM/DD/YYYY")}
        return row?.doNotRememberDate
            ? "DO NOT REMEMBER DATE"
            : `${moment(row.visitOrAdmissionDate)
                .tz(moment.tz.guess())
                .format("MM/DD/YYYY")}`;
    };

    const srNumberFormatter = (cell, row, rowIndex) => {
        if (props.currentPage > 1)
            return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
        else return <>{rowIndex + 1}</>;
    };
    //  const handleShowModal = (show, data) =>{

    //   if(show){
    //     setModalData(data);
    //   }else{
    //     setModalData({});
    //   }
    //   setShowModal(show);
    // }

    const notesFormatter = (cell, row) => {
        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="button-tooltip-3">Click To View Notes</Tooltip>
                }
            >
                <img
                    src="/images/pharmacy_workspace/notes_black_icn@2x.png"
                    alt=""
                    className="iconStyle"
                    style={{ cursor: "pointer" }}
                />
            </OverlayTrigger>
        );
    };
    const handleShowNotesModal = (show, data) => {
        if (show) {
            setNotesModalData(data);
        } else {
            setNotesModalData({});
        }
        setShowNotesModal(show);
    };

    const columns = [
        {
            dataField: "id",
            text: "No.",
            formatter: srNumberFormatter,
        },
        {
            dataField: "eventTimestamp",
            text: "REPORTED DATE/TIME ",
            formatter: dateFormatter,
        },
        {
            dataField: "visitType.visitType",
            text: "TYPE OF VISIT/ADMISSION",
        },
        {
            dataField: "visitOrAdmissionDate",
            text: "VISIT/ADMISSION DATE",
            formatter: admissionDateFormatter,
        },
        {
            dataField: "facilityName",
            text: "FACILITY NAME",
        },
        {
            dataField: "visitReason.reason",
            text: "REASON",
        },
        {
            dataField: "notes1",
            text: "NOTES",
            formatter: notesFormatter,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    handleShowNotesModal(true, row);
                },
            },
        },
    ];
    const defaultSorted = [
        {
            dataField: "eventTimestamp",
            order: "desc",
        },
    ];

    return (
        <>
            <div>
                <BootstrapTable
                    keyField="id"
                    data={
                        props.UnplannedMVList?.length
                            ? props.UnplannedMVList.sort((t1, t2) => {
                                if (t1.eventTimestamp > t2.eventTimestamp)
                                    return -1;
                                if (t1.eventTimestamp < t2.eventTimestamp)
                                    return 1;
                                return 0;
                            })
                            : []
                    }
                    columns={columns}
                    striped
                    hover
                    condensed
                    bordered={false}
                    defaultSorted={defaultSorted}
                />
                <GenericModal
                    key="notes"
                    showModal={showNotesModal}
                    handleShowModal={handleShowNotesModal}
                    ChildComponent={
                        <TaskNotes
                            data={notesModalData}
                            payload={{
                                patientId: notesModalData?.patientId,
                                noteModuleId: 1,
                                referenceId: notesModalData?.id,
                                eventTypeId: parseInt(
                                    notesModalData?.eventType
                                ),
                            }}
                            patientData={profileData?.profileData?.patientData}
                        />
                    }
                    variant={"white"}
                />
            </div>
        </>
    );
};

export default UnplannedMedicalVisitsList;
